import { styled } from 'styled-components';

export const InfoBlock = styled.div`
  padding: 16px;
  display: flex;
  flex-flow: column nowrap;
  gap: 4px;
  & + & {
    border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
  }
`;

export const InfoLabel = styled.div`
  ${({ theme }) => theme.typography.textMedium}
  color: ${({ theme }) => theme.colors.grey100_1};
`;

export const InfoName = styled.div`
  ${({ theme }) => theme.typography.textMedium}
  ${({ theme }) => theme.typography.weightMedium}
`;

export const InfoDate = styled.div`
  ${({ theme }) => theme.typography.textSmall}
`;
